var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SinglePage',{class:['template', _vm.overviewClass],attrs:{"page":_vm.displayedPage,"configId":_vm.config.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }